import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Badge,
  Input,
  Spinner,
  Table,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import * as savePostAction from "../../../store/bXljbGllbnRhbGJ1/actions"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import * as clientAction from "../../../store/bXlDbGllbnRDb2/actions"
import * as historyAction from "../../../store/cG9zdGFsYnVt/actions"
import { isEmpty } from "lodash"
import { ToastContainer, toast } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
import moment from "moment"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import * as eventClientAction from "../../../store/bXl3b3Jrc3Bob3Rv/actions"
import api from "helpers/Api"
import SimpleReactValidator from "simple-react-validator"
import * as newTatAction from "../../../store/bXljbGllbnRyZX/actions"

const MyClientColorCorrected = (props) => {
  const { dispatch, searchBtnStyle } = props

  const title = "Color Corrected"

  const [downloadLoading, setDownloadLoading] = useState(false)
  //simple validatioator
  const simpleValidator = useRef(new SimpleReactValidator())

  const [, forceUpdate] = useState()

  const [retouchIdAvailable, setRetouchIdAvailable] = useState(false)
  const [retouchId, setRetouchId] = useState("")
  const update = useSelector(
    (specificstate) => specificstate.myClientColorCorrected
  )
  const teamLeadId = localStorage.getItem("empId")
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const { magazine_details = [], recordsMetaData = {} } = update
  //sorting initial state
  const [sortingDropdown, setSortingDropdown] = useState({
    label: "Ascending",
    value: "Ascending",
  })
  const [sortingColumn, setSortingColumn] = useState({
    label: "Assigned Date",
    value: "assignedDate",
  })

  //Fetching API

  useEffect(() => {
    dispatch(clientAction.loadRecordsMetaData())
  }, [])
  useEffect(() => {
    if (recordsMetaData && !isEmpty(recordsMetaData.productCategoryOptions)) {
      const retouchOption = recordsMetaData.productCategoryOptions.find(
        (m) => m.label === "COLOR CORRECTED"
      )
      const newRetouchId = retouchOption ? retouchOption.value : ""

      if (newRetouchId) {
        setRetouchId(newRetouchId)
        setRetouchIdAvailable(true)
      }
    }
  }, [recordsMetaData])
  useEffect(() => {
    if (retouchIdAvailable) {
      dispatch(
        clientAction.loadClientMagazine({
          page: 1,
          limit: 50,
          productCategoryId: retouchId,
          teamLeadId: teamLeadId,
          sortingOrder: "Ascending",
          sortingFieldName: "assignedDate",
        })
      )
    }
  }, [retouchIdAvailable])
  //date format

  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate
  const empId = localStorage.getItem("empId")

  //date format from localstorage
  const authUser = localStorage.getItem("authUser")
  const todayDate = moment().format('YYYY-MM-DD')
  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""

  //column checkbox modal

  const [columnModal, setColumnModal] = useState(false)

  //Handle Change

  const [event, setEvent] = useState([])
  //Handle Change

  const [btnLoader, setBtnLoader] = useState(false)

  const [clientMagazineData, setClientMagazineData] = useState({
    leadNo: "",
    eventStartDate: "",
    eventEndDate: "",
    assignedFromDate: "",
    assignedToDate: "",
    brideName: "",
    groomName: "",
    ewName: "",
    tatFromDate: "",
    tatToDate: ''
  })
  const [deliverableStatus, setDeliverableStatus] = useState([])
  const [agent, setAgent] = useState([])
  const [ewName, setEwName] = useState([])
  const deliverOptions = !isEmpty(recordsMetaData.deliverOptions) ?
    recordsMetaData.deliverOptions.filter(data => data.label != "NOT APPLICABLE")
    : []
  const fuseAgentOptions = {
    keys: ["empCode", "label"],
  }
  const [agentKey, setAgentKey] = useState(false)
  const handleChange = (e) => {
    setClientMagazineData({
      ...clientMagazineData,
      [e.target.name]: e.target.value,
    })
  }

  const [inProgress, setInProgress] = useState("")
  const statusList = [
    {
      label: "INPROGRESS",
      value: true,
    },
  ]

  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setInProgress(value)
    } else {
      setInProgress(false)
    }
  }
  //tat new
  const simpleNewValidator = useRef(new SimpleReactValidator())

  const [, forceUpdate1] = useState()
  const [tatNewModal, setTatNewModal] = useState(false)
  const [tatNewData, setTatNewData] = useState({
    tat: "",
    remarks: "",
  })
  const handleTatNewChange = (e) => {
    setTatNewData({
      ...tatNewData,
      [e.target.name]: e.target.value,
    })
  }
  const [teamData, setTeamData] = useState({
    note: "",
  })

  const handleTeam = (e) => {
    setTeamData({ ...teamData, [e.target.name]: e.target.value })
  }
  //Team assign
  const [sortDirection] = useState("asc")

  const [multiTeamEmployee, setMultiTeamEmployee] = useState([])

  const [multiTeamData, setMultiTeamData] = useState({
    note: "",
  })
  const handleMultiTeam = (e) => {
    setMultiTeamData({ ...multiTeamData, [e.target.name]: e.target.value })
  }

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  //Search value
  const [searchValueList, setSearchValueList] = useState({})

  const searchValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
          page: pageChange ? pageCount : 1,
          limit: 50,
          productCategoryId: retouchId,
          teamLeadId: teamLeadId,
          sortingOrder: sortingDropdown.value,
          sortingFieldName: sortingColumn.value,
        }
        : {
          page: pageChange ? pageCount : 1,
          limit: 50,
          productCategoryId: retouchId,
          teamLeadId: teamLeadId,
          searchFilter: searchInput,
          sortingOrder: sortingDropdown.value,
          sortingFieldName: sortingColumn.value,
        }

  const deliverables =
    !isEmpty(deliverableStatus) && deliverableStatus.map((m) => m.value)
  const [clientType, setClientType] = useState([])
  const handleFilter = (e) => {
    e.preventDefault()

    var searchLeadNo =
      clientMagazineData && clientMagazineData ? clientMagazineData.leadNo : ""

    var searchInProgress = inProgress === true ? "INPROGRESS" : ""
    var searchEvent = event && event ? event.value : ""
    var searchFromDate =
      clientMagazineData && clientMagazineData.eventStartDate
        ? moment(clientMagazineData.eventStartDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      clientMagazineData && clientMagazineData.eventEndDate
        ? moment(clientMagazineData.eventEndDate).format("YYYY-MM-DD")
        : ""
    var searchEmp = agent && !isEmpty(agent) ? [agent.value] : ""
    var searchAssignedFromDate =
      clientMagazineData && clientMagazineData.assignedFromDate
        ? moment(clientMagazineData.assignedFromDate).format("YYYY-MM-DD")
        : ""
    var searchAssignedToDate =
      clientMagazineData && clientMagazineData.assignedToDate
        ? moment(clientMagazineData.assignedToDate).format("YYYY-MM-DD")
        : ""
    var searchGroom =
      clientMagazineData && clientMagazineData.groomName
        ? clientMagazineData.groomName
        : ""
    var searchBride =
      clientMagazineData && clientMagazineData.brideName
        ? clientMagazineData.brideName
        : ""
    var searchEwName = !isEmpty(ewName) ? [ewName.value] : ""
    var searchDeliverable = !isEmpty(deliverableStatus) ? deliverables : ""
    var searchTatFromDate =
      clientMagazineData && clientMagazineData.tatFromDate
        ? moment(clientMagazineData.tatFromDate).format("YYYY-MM-DD")
        : ""
    var searchTatToDate =
      clientMagazineData && clientMagazineData.tatToDate
        ? moment(clientMagazineData.tatToDate).format("YYYY-MM-DD")
        : ""
    var searchClientType = !isEmpty(clientType) ? clientType.value : ""
    var searchvalue = {}
    if (searchClientType) {
      searchvalue.clientType = searchClientType
    }
    if (searchTatFromDate) {
      searchvalue.tatFromDate = searchTatFromDate
    }
    if (searchTatToDate) {
      searchvalue.tatToDate = searchTatToDate
    }
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50
    searchvalue.productCategoryId = retouchId
    searchvalue.teamLeadId = teamLeadId
    searchvalue.sortingOrder = sortingDropdown.value
    searchvalue.sortingFieldName = sortingColumn.value
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
    if (searchEmp) {
      searchvalue.assignCrmId = searchEmp
    }
    if (searchAssignedFromDate) {
      searchvalue.assignedFromDate = searchAssignedFromDate
    }
    if (searchAssignedToDate) {
      searchvalue.assignedToDate = searchAssignedToDate
    }
    if (searchGroom) {
      searchvalue.groomName = searchGroom
    }
    if (searchBride) {
      searchvalue.brideName = searchBride
    }
    if (searchEwName) {
      searchvalue.assignedEmployeeId = searchEwName
    }
    if (searchDeliverable) {
      searchvalue.productionprocessstatus = searchDeliverable
    }
    if (searchInProgress) {
      searchvalue.subStatus = searchInProgress
    }
    setPageLoad(!pageLoad)
    setSearchValueList(searchvalue)

    dispatch(clientAction.loadClientMagazine(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)

    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }

  const resetForm = () => {
    setClientType([])
    setEvent([])
    setInProgress(false)
    setSearchInput("")
    setAgent([])
    setAgentKey(true)
    setTimeout(() => {
      setAgentKey(false)
    }, 0)
    setDeliverableStatus([])
    setSortingDropdown({ label: "Ascending", value: "Ascending" })
    setSortingColumn({ label: "Assigned Date", value: "assignedDate" })
    setClientMagazineData({
      ...clientMagazineData,
      leadNo: "",
      eventStartDate: "",
      eventEndDate: "",
      assignedFromDate: "",
      assignedToDate: "",
      brideName: "",
      groomName: "",
      ewName: "",
      tatFromDate: "",
      tatToDate: ''
    })

    setEwName([])
    setSearchValueList({
      page: 1,
      limit: 50,
      productCategoryId: retouchId,
      teamLeadId: teamLeadId,
    })
    dispatch(
      clientAction.loadClientMagazine({
        page: 1,
        limit: 50,
        productCategoryId: retouchId,
        teamLeadId: teamLeadId,
        sortingOrder: "Ascending",
        sortingFieldName: "assignedDate",
      })
    )
  }
  //Edit assign team lead
  const editTeamAssign = (data) => {
    const teamEmployeeDetails = !isEmpty(data)
      ? data.map((team) => {
        return {
          label: team.name,
          value: team._id,
        }
      })
      : []
    setTeamEmployee(teamEmployeeDetails)
  }
  const [teamEmployee, setTeamEmployee] = useState([])

  const [teamAssignModal, setTeamAssignModal] = useState(false)

  const [teamAssignData, setTeamAssignData] = useState("")

  const [teamAssignDetails, setTeamAssignDetails] = useState([])
  const [teamSubmitButton, setTeamSubmitButton] = useState(false)

  const [multiTeamModal, setMultiTeamModal] = useState(false)

  const [ewAttachmentModal, setEwAttachmentModal] = useState(false)
  const [ewAttachmentsDetails, setEwAttachmentsDetails] = useState("")

  const [crmAttachmentModal, setCrmAttachmentModal] = useState(false)
  const [crmAttachmentsDetails, setCrmAttachmentsDetails] = useState("")

  //pl Attachment
  const [plAttachmentModal, setPlAttachmentModal] = useState(false)
  const [plAttachmentsDetails, setPlAttachmentsDetails] = useState("")
  const [processData, setProcessData] = useState({
    notes: "",
  })
  const handleNotesChange = (e) => {
    setProcessData({ ...processData, [e.target.name]: e.target.value })
  }
  const operationStatusOptions = [
    { label: "EW QC Completed", value: "PS42" },
    { label: "Client Changes", value: "PS45" },
    { label: "Client Rework", value: "PS40" },
    { label: "Qc Recheck", value: "PS68" },
    { label: "On Hold", value: "PS67" },
  ]

  const [operationStatus, setOperationStatus] = useState([])
  const [updateProcess, setUpdateProcess] = useState("")
  const [processStatusModal, setProcessStatusModal] = useState(false)

  //assigned history modal
  const [historyModal, setHistoryModal] = useState(false)

  // columns data editable history details
  const [tatModal, setTatModal] = useState(false)
  const [tatUpdate, setTatUpdate] = useState(false)
  const [tatView, setTatView] = useState(false)

  //tatmodal
  const [tatData, setTatData] = useState({
    tatDate: "",
    link: "",
    remarks: "",
    deliverableQuantity: "",
  })

  const handleTatChange = (e) => {
    setTatData({
      ...tatData,
      [e.target.name]: e.target.value,
    })
  }
  const [tatDetails, setTatDetails] = useState("")
  const [tatAttachment, setTatAttachment] = useState([])

  const tatAttachmentChange = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      setTatAttachment(file)
      var teamUploadValue = tatAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setTatAttachment(teamUploadValue)
          }
        })
      }
    }
  }
  const [operationHistoryDetails, setOperationHistoryDetails] = useState("")
  const [processHistoryDetails, setProcessHistoryDetails] = useState("")

  const [eventServiceModal, setEventServiceModal] = useState(false)
  let slNo = 0
  const [tatHistoryDetails, setTatHistoryDetails] = useState([])
  const myClientMagazineTable =
    !isEmpty(magazine_details) &&
      magazine_details &&
      magazine_details.data.length > 0
      ? magazine_details.data.map((data) => {
        slNo = slNo + 1
        const teamArray =
          !isEmpty(data.assignedTeamlead) &&
          data.assignedTeamlead.length > 0 &&
          data.assignedTeamlead
            .map((m) => {
              const empName = !isEmpty(m) ? `${m.empCode} - ${m.name}` : ""
              return empName
            })
            .filter(Boolean)
        const teamName = teamArray.length > 0 ? teamArray.join(",") : "--"
        const employeeArray =
          !isEmpty(data.assignedEmployee) &&
          data.assignedEmployee.length > 0 &&
          data.assignedEmployee.map((m) => m.name).filter(Boolean)
        const employeeName =
          employeeArray.length > 0 ? employeeArray.join(",") : "--"
        const colorCode =
          !isEmpty(recordsMetaData) &&
          recordsMetaData.processStatusOptions &&
          recordsMetaData.processStatusOptions.length > 0 &&
          recordsMetaData.processStatusOptions.find(
            (_) => _.value === data.productionprocessstatus
          ) &&
          recordsMetaData.processStatusOptions.find(
            (_) => _.value === data.productionprocessstatus
          ).colorCode
        const crmName =
          !isEmpty(data.assignCrm) && data.assignCrm.length > 0
            ? data.assignCrm.map((m) => m.empCode + "-" + m.name).join()
            : "--"
        const createdDate = moment(data.leadCreatedAt)
        const assignedDate = moment(data.tlAssigneDate)
        const daysDifference =
          createdDate && assignedDate
            ? createdDate.isValid() && assignedDate.isValid()
              ? createdDate.diff(assignedDate, "days")
              : "--"
            : "--"
        const dayDiffValue =
          daysDifference !== "--" ? `${daysDifference}  days` : "--"
        //last status
        const currentDay = moment().startOf("day")
        const updateOn = data.updatedOn
          ? moment.utc(data.updatedOn).startOf("day")
          : ""
        const updateDifference =
          currentDay && updateOn
            ? updateOn.isValid() && currentDay.isValid()
              ? Math.ceil(currentDay.diff(updateOn, "days", true))
              : "--"
            : "--"
        const lastStatusValue =
          updateDifference != "--" ? `${updateDifference} days` : "--"

        return {
          _id: data._id,
          sNo: slNo,
          leadNo: data.leadNo,
          leadId: data.leadId,
          eventId: data.eventId,
          company: data.companyName,
          branch: data.branchName,
          clearanceStatusName: data.ecClearanceStatusName ? data.ecClearanceStatusName : "--",

          //deliverable
          deliverableName:
            data.delivarbleName !== null ? data.deliverableName : "--",
          count:
            data.count !== null && data.sheetLength !== null
              ? data.count + "/" + data.sheetLength
              : "-",
          deliverableId: data.deliverableId ? data.deliverableId : "--",
          leadDeliverableId: data.leadDeliverableId
            ? data.leadDeliverableId
            : "",
          productId: data.productId ? data.productId : "",
          operationId: data.oprationId ? data.oprationId : "",
          productName: data.productName ? data.productName : "",
          quantity: data.quantity ? data.quantity : "--",
          remarks: data.plRemark ? data.plRemark : "--",
          crmAttachment: data.crmAttachments ? data.crmAttachments : "",
          attachments: data.attachments ? data.attachments : "",
          crmRemarks: data.crmRemarks ? data.crmRemarks : "--",
          clientCode: data.clientCode ? data.clientCode : "--",
          clientName: data.clientName ? data.clientName : "--",
          clientProfile: data.clientProfileName
            ? data.clientProfileName
            : "--",
          link: data.link ? data.link : "--",
          tatDate: data.tat ? moment(data.tat).format(dateFormat) : "--",
          eventLocation: !isEmpty(data.eventLocation)
            ? data.eventLocation.map((data) => data).join(",")
            : "--",
          eventDate: !isEmpty(data.eventDetails)
            ? data.eventDetails
              .map((m) => moment(m.eventDate).format(dateFormat))
              .join()
            : "--",
          event: !isEmpty(data.eventName)
            ? data.eventName.map((m) => m).join()
            : "--",
          leadDate: data.leadDate
            ? moment(data.leadDate).format(dateFormat)
            : "--",
          crmName: crmName,
          productLeadName: teamName ? teamName : "--",
          endWorkerName: (
            <>
              <div className="d-flex flex-row align-items-center">
                <Button
                  className="btn btn-warning text-nowrap"
                  onClick={() => {
                    setTeamAssignModal(true)
                    setTeamAssignData(data)
                    handleClearModal()
                    if (
                      !isEmpty(data.assignedEmployee) &&
                      data.assignedEmployee.length > 0
                    ) {
                      editTeamAssign(data.assignedEmployee)
                    }
                  }}
                >
                  {!isEmpty(data.assignedEmployee) &&
                    data.assignedEmployee.length > 0
                    ? employeeArray
                    : "Assign Team"}
                </Button>

                <div className="ms-auto ml-2">
                  <Input
                    type="checkbox"
                    checked={teamAssignDetails.some(
                      (item) => item.oprationId === data.oprationId
                    )}
                    style={{
                      width: "15px",
                      height: "15px",
                      marginLeft: "10px",
                    }}
                    onChange={(e) => {
                      if (
                        e.target.checked &&
                        !teamAssignDetails.find(
                          (item) => item.oprationId === data.oprationId
                        )
                      ) {
                        setTeamAssignDetails([...teamAssignDetails, data])
                      } else {
                        setTeamAssignDetails(
                          teamAssignDetails.filter(
                            (item) => item.oprationId !== data.oprationId
                          )
                        )
                      }
                      const anyChecked = teamAssignDetails.some(
                        (item) => item.oprationId !== data.oprationId
                      )
                      setTeamSubmitButton(anyChecked)
                    }}
                  />
                </div>
              </div>
            </>
          ),
          teamDetails: employeeName ? employeeName : "--",
          ewAttachments: data.ewAttachments ? data.ewAttachments : "",
          ewRemarks: data.ewRemark ? data.ewRemark : "--",
          operationStatus: data.productioProcessStatusName,
          operationStatusId: data.productionprocessstatus,
          colorCode: colorCode,
          specialInstructions: data.specialInstruction
            ? data.specialInstruction
            : "--",
          instructions: data.specialInstruction
            ? data.specialInstruction.length
            : 0,
          plAttachments: data.plAttachments ? data.plAttachments : "",
          assignedHistory: data.assignedHistory,
          groomName: data.groomName ? data.groomName : "--",
          brideName: data.brideName ? data.brideName : "--",
          overallStatus: data.overAllStatus ? data.overAllStatus : "--",
          operationHistory: !isEmpty(data.operationalHistory)
            ? data.operationalHistory
            : [],
          processHistory: !isEmpty(data.processHistory)
            ? data.processHistory
            : [],
          subStatus: data.subStatus ? data.subStatus : "--",
          deliverableQuantity: data.deliverableQuantity
            ? data.deliverableQuantity
            : "--",
          aging: data.deliverableAge
            ? `${data.deliverableAge}  days`
            : dayDiffValue,
          assignedDate: !isEmpty(data.tlAssigneDate)
            ? moment(data.tlAssigneDate).format(dateFormat)
            : "--",
          cpStatus:
            data.clientProfileStatus && data.clientProfileStatus != null
              ? data.clientProfileStatus
              : "--",
          cpRemarks: data.clientProfileRemarks
            ? data.clientProfileRemarks
            : "--",
          lastStatus: lastStatusValue,
          tatHistory: !isEmpty(data.tatHistory) ? data.tatHistory : [],
          clientType: data.leadQuotationRange,
          isEscalation: data.isOperationEscalation
        }
      })
      : []

  useEffect(() => {
    if (teamAssignDetails.length > 0) {
      setTeamSubmitButton(true)
    } else {
      setTeamSubmitButton(false)
    }
  }, [teamAssignDetails])

  //Modal section
  const [instructionsModal, setInstructionsModal] = useState(false)
  const [attachmentModal, setAttachmentModal] = useState(false)
  const [instructionsDetails, setInstructionsDetails] = useState("")
  const [modalAttachment, setModalAttachment] = useState([])
  const [productArrayId, setProductArrayId] = useState("")

  const modalAttachmentChange = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = modalAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setModalAttachment(teamUploadValue)
          }
        })
      }
    }
  }
  const getCellStyle = (row) => {
    const currentDate = moment()
    const tatDate = row.tatDate ? moment(row.tatDate, "DD/MM/YYYY") : null
    if (row.tatDate === "--") {
      return {
        backgroundColor: "",
      }
    } else if (tatDate && tatDate.isBefore(currentDate)) {
      return {
        backgroundColor: "#3abd856e",
      }
    } else if (tatDate && tatDate.isAfter(currentDate)) {
      return {
        backgroundColor: "#f78f8f",
      }
    }
    return {}
  }
  const getCellStyleWithColor = (row) => {
    const currentDate = moment()
    const tatDate = row.tatDate ? moment(row.tatDate, "DD/MM/YYYY") : null
    if (row.tatDate === "--") {
      return {
        backgroundColor: '#f78f8f',
        justifyContent: "center",
        textAlign: "center"
      }
    } else if (tatDate && tatDate.isBefore(currentDate)) {
      return {
        backgroundColor: "#3abd856e",
        justifyContent: "center",
        textAlign: "center"
      }
    } else if (tatDate && tatDate.isAfter(currentDate)) {
      return {
        backgroundColor: "#f78f8f",
        justifyContent: "center",
        textAlign: "center"
      }
    }
    return {}
  }
  const getCellStyleWithText = (row) => {
    const currentDate = moment()
    const tatDate = row.tatDate ? moment(row.tatDate, "DD/MM/YYYY") : null
    if (row.tatDate === "--") {
      return {
        backgroundColor: "",
      }
    } else if (tatDate && tatDate.isBefore(currentDate)) {
      return {
        backgroundColor: "#3abd856e",
      }
    } else if (tatDate && tatDate.isAfter(currentDate)) {
      return {
        backgroundColor: "#f78f8f",
      }
    }
    return {}
  }
  ///Modal Attachment section end
  //assign history api call
  const assignHistory = (data) => {
    const historyPayload = {
      operationId: data.operationId,
      deliverableId: data.leadDeliverableId,
      mode: "POST",
    }
    setHistoryModal(true)
    setTimeout(() => {
      dispatch(historyAction.loadProductionAssignHistory(historyPayload))
    }, 500)
  }
  const historyUpdate = useSelector((state) => state.postalbum)

  const { history_details = [] } = historyUpdate
  const loadEventData = (payload) => {
    setEventServiceModal(true)
    setTimeout(() => {
      dispatch(savePostAction.loadEvent(payload))
    }, 500)
  }
  const eventUpdate = useSelector(
    (specificstate) => specificstate.myclientalbum
  )
  const { event_data = [] } = eventUpdate
  const clientEventUpdate = useSelector(
    (specificstate) => specificstate.myWorksCompleted
  )
  const { clientEvent_data = [] } = clientEventUpdate

  const [clientEventModal, setClientEventModal] = useState(false)
  const loadClientEvent = (payload) => {
    setClientEventModal(true)
    setTimeout(() => {
      dispatch(eventClientAction.loadClientEvent(payload))
    })
  }
  const [tatHistoryModal, setTatHistoryModal] = useState(false)
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      editable: false,
      csvType: Number,
      style: (cell, row) => getCellStyle(row),
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      editable: false,
      hidden: false,
      formatter: (cellContent, row) => {
        const payload = {
          leadEventId: row.eventId,
          leadId: row.leadId,
        }
        return (
          <div>
            {" "}
            <a onClick={() => loadEventData(payload)}>{cellContent}</a>
          </div>
        )
      },
      style: (cell, row) => getCellStyleWithText(row),
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "isEscalation",
      text: "Is Escalation",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyleWithColor(row),
      formatter: (cellContent) => {

        return (
          cellContent == true ? <Badge
            color="danger"
            style={{
              display: "inline-block",
              width: "35px",        // Equal width and height for a circle
              height: "35px",
              borderRadius: "50%",

            }}
          /> : "--"
        )


      },
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "clientType",
      text: "Client Type",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "100px",
      },
      style: (cell, row) => getCellStyleWithColor(row),
      formatter: (cellContent) => {
        let badgeStyle

        // Determine the badge style based on cell content
        switch (cellContent) {
          case "Green":
            badgeStyle = { backgroundColor: "#28a745" } // Bootstrap success color 
            break
          case "Orange":
            badgeStyle = { backgroundColor: "#FFA500" } //  orange color
            break
          case "Blue":
            badgeStyle = { backgroundColor: "#033dfc" } // Blue color
            break
          default:
            return "--"
        }


        return (
          <span
            className={"badge"}
            style={{
              ...badgeStyle,
              display: "inline-block",
              width: "35px",        // Equal width and height for a circle
              height: "35px",
              borderRadius: "50%",
              textAlign: "center"
            }}
          />
        )
      }
    },//
    {
      dataField: "onlyEngagement",
      text: "Only Engagement",
      hidden: false,
      editable: false,
      formatter: (cellContent, row) => {
        console.log(cellContent, row, "kk")
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#c5ff00",
                    backgroundColor: "#c5ff00"
                  }}
                /> : "--"}
              </div>
              {cellContent && row.onlyEngagementStatus ? `(${row.onlyEngagementStatus})` : ""}
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "company",
      style: (cell, row) => getCellStyle(row),
      text: "Company",
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "branch",
      text: "Branch",
      editable: false,
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "deliverableName",
      text: "Deliverable Name",
      hidden: true,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyleWithText(row),
      formatter: (cellContent, row) => {
        const payload = {
          clientNo: row.clientCode,
        }
        return (
          <div>
            {" "}
            <a onClick={() => loadClientEvent(payload)}>{cellContent}</a>
          </div>
        )
      },

      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "clientName",
      text: "Client Name",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "cpStatus",
      text: "CP Status",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "clientProfile",
      text: "Client Profile",
      editable: false,
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "crmName",
      text: "CRM Name",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "productLeadName",
      text: "Product Lead Name",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "endWorkerName",
      text: "Team Name",
      editable: false,
      hidden: false,
      csvExport: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "aging",
      text: "Aging",
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "assignedDate",
      text: "Assigned Date",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "productName",
      text: "Product Name",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "count",
      text: "Count/Sheet",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "tatDate",
      text: "TAT Date",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "175px",
      },
      formatter: (cellContent, row) => {
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              {row.tatDate}
            </Col>
            <Col md="2" lg="2" sm="2">
              <button
                style={{
                  background: "#17b77d",
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  setTatNewModal(true)
                  setOperationHistoryDetails(row.operationHistory)
                  setTatDetails(row)
                  setTatNewData({
                    tat: "",
                    remarks: "",
                  })
                }}
              >
                <i
                  className="fas fa-edit icon-btn"
                  style={{ fontSize: "10px" }}
                ></i>
              </button>
            </Col>
            <Col md="2" lg="2" xl="2">
              <div style={{ marginLeft: "10px" }}>
                <i
                  className="fas fa-eye text-info fs-5"
                  onClick={() => {
                    setTatHistoryModal(true)
                    setTatHistoryDetails(row.tatHistory)
                  }}
                ></i>
              </div>
            </Col>
          </Row>
        )
      },
    },
    {
      dataField: "link",
      text: "Deliverable link",
      editable: false,
      hidden: false,
      csvExport: true,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "deliverableQuantity",
      text: "Deliverable Quantity",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "168px",
      },
    },
    {
      dataField: "remarks",
      text: "Deliverable Remarks",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      editable: false,
      headerStyle: {
        minWidth: "170px",
      },
    },

    {
      dataField: "plAttachments",
      text: "Deliverable Attachment",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        const attachCount =
          !isEmpty(row.plAttachments) && row.plAttachments.length > 0
            ? row.plAttachments.length
            : 0
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              <div>
                <a
                  onClick={() => {
                    setPlAttachmentModal(true)
                    setPlAttachmentsDetails(row.plAttachments)
                  }}
                >
                  <span
                    style={{
                      textDecoration: "underline",
                      color: "#E40D8C",
                    }}
                  >
                    View
                  </span>
                </a>
              </div>
            </Col>
            <Col md="4" lg="4" sm="4">
              <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {attachCount}
                </span>
              </div>
            </Col>
          </Row>
        )
      },
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "event",
      text: "Event Name",
      hidden: false,
      csvExport: false,
      style: (cell, row) => getCellStyle(row),
      editable: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "eventLocation",
      text: "Event Location",
      style: (cell, row) => getCellStyle(row),
      editable: false,
      hidden: true,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "paymentStatus",
      text: "Payment Status",
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "allowOrder",
      text: "Allow Order",
      hidden: true,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "attachments",
      text: "Attachment",
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      editable: false,
      formatter: (cellContent, row) => {
        const attachments =
          !isEmpty(row.attachments) && row.attachments.length > 0
            ? row.attachments[0]
            : ""
        return (
          <div className="d-flex flex-row">
            <Button
              className="btn btn-warning"
              onClick={() => {
                setProductArrayId(row)
                setAttachmentModal(true)
              }}
            >
              Attachment
            </Button>
            {!isEmpty(attachments) ? (
              <a
                onClick={() => window.open(attachments, "_blank")}
                rel="noopener noreferrer"
                className="mx-2 mt-2"
              >
                <span
                  style={{
                    textDecoration: "underline",
                    color: "#E40D8C",
                  }}
                >
                  View
                </span>
              </a>
            ) : (
              ""
            )}
          </div>
        )
      },
      headerStyle: {
        minWidth: "185px",
      },
    },
    {
      dataField: "specialInstructions",
      text: "Special Instructions",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        return (
          <div>
            <Button
              className="btn btn-info"
              onClick={() => {
                setInstructionsDetails(row.specialInstructions)
                setInstructionsModal(true)
              }}
            >
              Instructions
            </Button>
          </div>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "crmRemarks",
      text: "CRM Remarks",
      editable: false,
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "quantity",
      text: "Quantity",
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      editable: false,
      headerStyle: {
        minWidth: "100px",
      },
    },

    {
      dataField: "assignedHistory",
      text: "Agent Assign History",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        return (
          <div
            onClick={() => {
              assignHistory(row)
              setLoading(true)
              setTimeout(() => {
                setLoading(false)
                setHistoryModal(true)
              }, 1500)
              // setHistoryDetails(row.assignedHistory)
            }}
          >
            <span
              style={{
                textDecoration: "underline",
                color: "#E40D8C",
              }}
            >
              History
            </span>
          </div>
        )
      },
      csvExport: true,
      headerStyle: {
        minWidth: "190px",
      },
    },

    {
      dataField: "ewAttachments",
      text: "EW Attachment",
      hidden: true,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        return (
          <div>
            <a
              onClick={() => {
                setEwAttachmentModal(true)
                setEwAttachmentsDetails(row.ewAttachments)
              }}
            >
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                View
              </span>
            </a>
          </div>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "ewRemarks",
      text: "EW Remarks",
      hidden: true,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "crmAttachments",
      text: "CRM Attachment",
      hidden: true,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        return (
          <div>
            <a
              onClick={() => {
                setCrmAttachmentModal(true)
                setCrmAttachmentsDetails(row.crmAttachments)
              }}
            >
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                View
              </span>
            </a>
          </div>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "history",
      text: "Deliverable Update History",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex flex-row align-items-center">
            <Button
              className="btn btn-warning"
              onClick={() => {
                setTatModal(true)
                setTatUpdate(true)
                setTatView(false)
                setTatDetails(row)
                setTatData({
                  ...tatData,
                  tatDate: "",
                  link: "",
                  remarks: "",
                  deliverableQuantity: "",
                })
                //   setTatAttachment([])
              }}
            >
              Update
            </Button>
            <div style={{ marginLeft: "10px" }}>
              <i
                className="fas fa-eye text-info fs-5"
                onClick={() => {
                  setTatModal(true)
                  setTatUpdate(false)
                  setTatView(true)
                  setOperationHistoryDetails(row.operationHistory)
                }}
              ></i>
            </div>
          </div>
        )
      },
      headerStyle: {
        minWidth: "205px",
      },
    },
    {
      dataField: "overallStatus",
      text: "Overall Status",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "subStatus",
      text: "Sub Status",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "125px",
      },
    },

    {
      dataField: "lastStatus",
      text: "Last Status",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "operationStatus",
      text: "Deliverable Status",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              {!isEmpty(row.operationStatus) ? (
                <button
                  style={{
                    background: row.colorCode,
                    border: "none",
                    cursor: "pointer",
                    color: "white",
                    padding: "2px",
                    borderRadius: "4px",
                  }}
                >
                  {row.operationStatus}
                </button>
              ) : (
                "--"
              )}
            </Col>
            <Col md="2" lg="2" sm="2">
              <button
                style={{
                  background: "#17b77d",
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  setUpdateProcess(row)
                  setProcessStatusModal(true)
                  simpleProcessValidator.current.hideMessages()
                  setProcessData({ ...processData, notes: "" })
                  setOperationAttachment([])
                  setOperationStatus([])
                  setProcessHistoryDetails(row.processHistory)
                }}
              >
                <i
                  className="fas fa-edit icon-btn"
                  style={{ fontSize: "10px" }}
                ></i>
              </button>
            </Col>
          </Row>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "clearanceStatusName",
      text: "Clearance Status",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "150px",
      },
      style: (cell, row) => getCellStyle(row),
    },
  ]

  //Data Table section
  const clientDataTable = !isEmpty(clientEvent_data)
    ? clientEvent_data.map((data, index) => {
      //////////////
      const eventName = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventName).join(",")
        : "--"
      const eventNo = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventNo).join(",")
        : "--"
      const eventDate = !isEmpty(data.eventDetails)
        ? data.eventDetails
          .map((m) => moment(m.eventDate).format(dateFormat))
          .join(",")
        : "--"
      const startTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.startTime).join(",")
        : "--"
      const endTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.endTime).join(",")
        : "--"
      const venue = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.venueLocation).join(",")
        : "--"
      return {
        index: index,
        key: index,
        leadId: data.leadId,
        leadNo: data.leadNo,
        sNo: index + 1,
        serviceCount: !isEmpty(data.serviceDetails)
          ? data.serviceDetails.length
          : 0,
        isCommit: data.isCommit,
        eventName: eventName,
        eventNo: eventNo,
        eventDate: eventDate,
        startTime: startTime,
        endTime: endTime,
        venueLocation: venue,
        serviceDetails: data.serviceDetails,
      }
    })
    : []

  //table columns
  const clientColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      editable: false,
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      csvExport: false,
      hidden: false,
      formatter: (cellContent, row) => {
        return <span>{row.leadNo}</span>
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "serviceCount",
      text: "Services",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.serviceCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "isCommit",
      text: "Commit",
      headerStyle: {
        minWidth: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isCommit === true ? "success" : "danger"}
            style={{ padding: "6px", fontSize: "12px" }}
          >
            {row.isCommit === true ? "Yes" : "No"}
          </Badge>
        )
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventNo",
      text: "Event No",
      editable: false,
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]
  const clientExpandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Team Shooter
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sub Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                File Count
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Size
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Remarks
              </th>
            </tr>
          </thead>
          <tbody>
            {row &&
              !isEmpty(row.serviceDetails) &&
              row.serviceDetails.length > 0 ? (
              row.serviceDetails.map((data, index) => {
                const serviceName = !isEmpty(data.serviceId)
                  ? data.serviceId.serviceName
                  : "--"
                const freelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceMainShooterName
                    )
                    : []

                const freelancerName =
                  !isEmpty(freelancer) && freelancer.length > 0
                    ? freelancer.join(",")
                    : "--"

                const subFreelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceSubShooterName
                    )
                    : []

                const subFreelancerName =
                  !isEmpty(subFreelancer) && subFreelancer.length > 0
                    ? subFreelancer.join(",")
                    : "--"

                const shooterName = !isEmpty(data.teamEmployeeShooterId)
                  ? data.teamEmployeeShooterId.empCode +
                  "-" +
                  data.teamEmployeeShooterId.name
                  : "--"
                return (
                  <tr key={index}>
                    <td>{data.serviceNo ? data.serviceNo : "--"}</td>
                    <td>{serviceName}</td>
                    <td>{shooterName}</td>
                    <td>{freelancerName}</td>
                    <td>{subFreelancerName}</td>
                    <td>
                      {data.serviceLevelStatusName
                        ? data.serviceLevelStatusName
                        : "--"}
                    </td>
                    <td>{data.fileCount ? data.fileCount : "--"}</td>
                    <td>{data.size ? data.size : "--"}</td>
                    <td>{data.remarks ? data.remarks : "--"}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={8}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),

    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  // pagination options
  const clientOptions = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  //event modal event_data

  //Data Table section
  const deliverDataTable = !isEmpty(event_data)
    ? event_data.map((data, index) => {
      const eventName = !isEmpty(data.eventDetails)
        ? data.eventDetails.eventName
        : "--"
      const eventNo = !isEmpty(data.eventDetails)
        ? data.eventDetails.eventNo
        : "--"
      const eventDate = !isEmpty(data.eventDetails)
        ? moment(data.eventDetails.eventDate).format(dateFormat)
        : "--"
      const startTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.startTime
        : "--"
      const endTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.endTime
        : "--"
      const venue = !isEmpty(data.eventDetails)
        ? data.eventDetails.venueLocation
        : "--"

      return {
        index: index,
        key: index,
        leadId: data.leadId,
        sNo: index + 1,
        serviceCount: !isEmpty(data.serviceDetails)
          ? data.serviceDetails.length
          : 0,
        isCommit: data.isCommit,
        eventName: eventName,
        eventNo: eventNo,
        eventDate: eventDate,
        startTime: startTime,
        endTime: endTime,
        venueLocation: venue,
        serviceDetails: data.serviceDetails,
      }
    })
    : []

  //table columns
  const eventColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      editable: false,
    },
    {
      dataField: "serviceCount",
      text: "Services",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.serviceCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "isCommit",
      text: "Commit",
      headerStyle: {
        minWidth: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isCommit === true ? "success" : "danger"}
            style={{ padding: "6px", fontSize: "12px" }}
          >
            {row.isCommit === true ? "Yes" : "No"}
          </Badge>
        )
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventNo",
      text: "Event No",
      editable: false,
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]
  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Team Shooter
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sub Freelancer Name
              </th>
            </tr>
          </thead>
          <tbody>
            {row &&
              !isEmpty(row.serviceDetails) &&
              row.serviceDetails.length > 0 ? (
              row.serviceDetails.map((data, index) => {
                const serviceName = !isEmpty(data.serviceId)
                  ? data.serviceId.serviceName
                  : "--"
                const freelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceMainShooterName
                    )
                    : []

                const freelancerName =
                  !isEmpty(freelancer) && freelancer.length > 0
                    ? freelancer.join(",")
                    : "--"

                const subFreelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceSubShooterName
                    )
                    : []

                const subFreelancerName =
                  !isEmpty(subFreelancer) && subFreelancer.length > 0
                    ? subFreelancer.join(",")
                    : "--"

                const shooterName = !isEmpty(data.teamEmployeeShooterId)
                  ? data.teamEmployeeShooterId.empCode +
                  "-" +
                  data.teamEmployeeShooterId.name
                  : "--"
                return (
                  <tr key={index}>
                    <td>{data.serviceNo ? data.serviceNo : "--"}</td>
                    <td>{serviceName}</td>
                    <td>{shooterName}</td>
                    <td>{freelancerName}</td>
                    <td>{subFreelancerName}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={8}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),

    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  // pagination options
  const options = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  //Operations Status Attachment

  const [operationAttachment, setOperationAttachment] = useState([])

  const operationAttachmentChange = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      setOperationAttachment(file)
      var teamUploadValue = operationAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setOperationAttachment(teamUploadValue)
          }
        })
      }
    }
  }
  //operation process submit
  const simpleProcessValidator = useRef(new SimpleReactValidator())
  const [, forceUpdated] = useState()
  const operationStatusNewOptions = operationStatusOptions.filter(m => m.value != updateProcess.operationStatusId)
  const processSubmit = () => {
    if (simpleProcessValidator.current.allValid()) {
      const submitStatus = {
        operationId: updateProcess.operationId,
        mode: "PL",
        productionprocessstatus: operationStatus.value,
        notes: processData.notes,
        attachment: operationAttachment,
      }

      dispatch(clientAction.updateProcess(submitStatus))
      setProcessStatusModal(false)
      setTimeout(() => {
        dispatch(clientAction.loadClientMagazine(searchValue))
        toast.success("Process Status Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 1000)
    } else {
      simpleProcessValidator.current.showMessages()
      forceUpdated(1)
      setProcessStatusModal(true)
    }
  }
  //Attachment Modal start
  const handleAttachment = () => {
    const tat_details = {
      plAttachments: modalAttachment,
      deliverableId: productArrayId.leadDeliverableId,
      productionId: productArrayId.operationId,
    }
    setAttachmentModal(false)
    dispatch(clientAction.addTat(tat_details))

    setTimeout(() => {
      dispatch(clientAction.loadClientMagazine(searchValue))
      toast.success("Attachment updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1500)
  }

  //Attachment Modal end

  const historySubmit = () => {
    if (simpleValidator.current.allValid()) {
      const tat_details = {
        productionId: tatDetails.operationId,
        deliverableId: tatDetails.leadDeliverableId,
        plRemark: tatData.remarks,
        quantity: tatData.deliverableQuantity,
        link: tatData.link,
        // tat: !isEmpty(tatData.tatDate) ? tatData.tatDate : "",
        plAttachments: !isEmpty(tatAttachment) ? tatAttachment : "",
      }
      dispatch(clientAction.addTat(tat_details))
      setTatModal(false)
      setTimeout(() => {
        dispatch(clientAction.loadClientMagazine(searchValue))
        toast.success("PL Deliverable Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setTatModal(true)
    }
  }
  //tat new update
  const historyNewSubmit = (e) => {
    e.preventDefault()
    if (simpleNewValidator.current.allValid()) {
      const tat_details = {
        productionId: tatDetails.operationId,
        deliverableId: tatDetails.leadDeliverableId,
        tat: !isEmpty(tatNewData.tat) ? tatNewData.tat : "",
        remark: !isEmpty(tatNewData.remarks) ? tatNewData.remarks : "",
      }

      dispatch(newTatAction.addTatEdit(tat_details))
      setTatNewModal(false)
      setTimeout(() => {
        dispatch(clientAction.loadClientMagazine(searchValue))
        toast.success("PL Deliverable Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 1000)
    } else {
      simpleNewValidator.current.showMessages()
      forceUpdate1(1)
      setTatNewModal(true)
    }
  }
  const [columns, setColumns] = useState(initialColumns)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  const [loading, setLoading] = useState(false)

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      clientAction.loadClientMagazine({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
        productCategoryId: retouchId,
        teamLeadId: teamLeadId,
        sortingOrder: sortingDropdown.value,
        sortingFieldName: sortingColumn.value,
      })
    )

    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchLeadNo =
      clientMagazineData && clientMagazineData ? clientMagazineData.leadNo : ""
    var searchInProgress = inProgress === true ? "INPROGRESS" : ""
    var searchEvent = event && event ? event.value : ""
    var searchFromDate =
      clientMagazineData && clientMagazineData.eventStartDate
        ? moment(clientMagazineData.eventStartDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      clientMagazineData && clientMagazineData.eventEndDate
        ? moment(clientMagazineData.eventEndDate).format("YYYY-MM-DD")
        : ""
    var searchEmp = agent && !isEmpty(agent) ? [agent.value] : ""
    var searchAssignedFromDate =
      clientMagazineData && clientMagazineData.assignedFromDate
        ? moment(clientMagazineData.assignedFromDate).format("YYYY-MM-DD")
        : ""
    var searchAssignedToDate =
      clientMagazineData && clientMagazineData.assignedToDate
        ? moment(clientMagazineData.assignedToDate).format("YYYY-MM-DD")
        : ""
    var searchGroom =
      clientMagazineData && clientMagazineData.groomName
        ? clientMagazineData.groomName
        : ""
    var searchBride =
      clientMagazineData && clientMagazineData.brideName
        ? clientMagazineData.brideName
        : ""
    var searchEwName = !isEmpty(ewName) ? [ewName.value] : ""
    var searchDeliverable = !isEmpty(deliverableStatus) ? deliverables : ""
    var searchTatFromDate =
      clientMagazineData && clientMagazineData.tatFromDate
        ? moment(clientMagazineData.tatFromDate).format("YYYY-MM-DD")
        : ""
    var searchTatToDate =
      clientMagazineData && clientMagazineData.tatToDate
        ? moment(clientMagazineData.tatToDate).format("YYYY-MM-DD")
        : ""
    var searchClientType = !isEmpty(clientType) ? clientType.value : ""
    var searchvalue = {}
    if (searchClientType) {
      searchvalue.clientType = searchClientType
    }
    if (searchTatFromDate) {
      searchvalue.tatFromDate = searchTatFromDate
    }
    if (searchTatToDate) {
      searchvalue.tatToDate = searchTatToDate
    }
    searchvalue.productCategoryId = retouchId
    searchvalue.teamLeadId = teamLeadId
    searchvalue.sortingOrder = sortingDropdown.value
    searchvalue.sortingFieldName = sortingColumn.value
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
    if (searchEmp) {
      searchvalue.assignCrmId = searchEmp
    }
    if (searchAssignedFromDate) {
      searchvalue.assignedFromDate = searchAssignedFromDate
    }
    if (searchAssignedToDate) {
      searchvalue.assignedToDate = searchAssignedToDate
    }
    if (searchGroom) {
      searchvalue.groomName = searchGroom
    }
    if (searchBride) {
      searchvalue.brideName = searchBride
    }
    if (searchEwName) {
      searchvalue.assignedEmployeeId = searchEwName
    }
    if (searchDeliverable) {
      searchvalue.productionprocessstatus = searchDeliverable
    }
    if (searchInProgress) {
      searchvalue.subStatus = searchInProgress
    }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/get_qutation_delivareble_post_excel_export`, searchvalue)
      .then((response) => {
        //sorting
        const postExportInitialArray =
          !isEmpty(response) && response.data && response.data.data.length > 0
            ? response.data.data
            : []
        const sortingExportTable = [...postExportInitialArray]

        const sortedExportData = sortingExportTable.sort((a, b) => {
          const dateA = new Date(a.tlAssigneDate)
          const dateB = new Date(b.tlAssigneDate)
          return sortDirection === "asc" ? dateA - dateB : dateB - dateA
        })

        const postExportDataTable = !isEmpty(sortedExportData)
          ? sortedExportData.map((data, index) => {
            const eventNameList = !isEmpty(data.eventName)
              ? data.eventName.map((m) => m).join(",")
              : "--"
            const eventName = JSON.stringify(eventNameList).replace(
              /","/g,
              "\n"
            )
            const teamArray =
              !isEmpty(data.assignedTeamlead) &&
              data.assignedTeamlead.length > 0 &&
              data.assignedTeamlead
                .map((m) => {
                  const empName = !isEmpty(m)
                    ? `${m.empCode} - ${m.name}`
                    : ""
                  return empName
                })
                .filter(Boolean)
            const teamName = teamArray.length > 0 ? teamArray.join() : "--"
            const teamNameValue = JSON.stringify(teamName).replace(
              /","/g,
              "\n"
            )
            const employeeArray =
              !isEmpty(data.assignedEmployee) &&
              data.assignedEmployee.length > 0 &&
              data.assignedEmployee
                .map((m) => {
                  const empName = !isEmpty(m)
                    ? `${m.empCode} - ${m.name}`
                    : ""
                  return empName
                })
                .filter(Boolean)
            const employeeName =
              employeeArray.length > 0 ? employeeArray.join() : "--"
            const employeeNameValue = JSON.stringify(employeeName).replace(
              /","/g,
              "\n"
            )
            const groomName = JSON.stringify(data.groomName).replace(
              /","/g,
              "\n"
            )
            const brideName = JSON.stringify(data.brideName).replace(
              /","/g,
              "\n"
            )

            const plRemarks = JSON.stringify(data.plRemark)
            const plAttachments =
              !isEmpty(data.plAttachments) &&
              data.plAttachments.length > 0 &&
              data.plAttachments.map((m) => m).filter(Boolean)
            const plAttachmentsArray =
              plAttachments.length > 0 ? plAttachments.join() : "--"
            const plAttachmentsValue =
              plAttachmentsArray !== "--"
                ? JSON.stringify(plAttachmentsArray).replace(/","/g, "\n")
                : "--"
            const count =
              data.count !== null && data.sheetLength !== null
                ? data.count + "/" + data.sheetLength
                : "--"
            const countValue = JSON.stringify(count)
            const cpRemarks = !isEmpty(data.clientProfileRemarks)
              ? data.clientProfileRemarks.replace(/[\r\n,.]/gm, "")
              : "--"
            const createdDate = moment(data.leadCreatedAt)
            const assignedDate = moment(data.tlAssigneDate)
            const daysDifference =
              createdDate && assignedDate
                ? createdDate.isValid() && assignedDate.isValid()
                  ? createdDate.diff(assignedDate, "days")
                  : "--"
                : "--"
            const dayDiffValue =
              daysDifference !== "--" ? `${daysDifference}  days` : "--"
            //last status
            const currentDay = moment().startOf("day")
            const updateOn = data.updatedOn
              ? moment.utc(data.updatedOn).startOf("day")
              : ""
            const updateDifference =
              currentDay && updateOn
                ? updateOn.isValid() && currentDay.isValid()
                  ? Math.ceil(currentDay.diff(updateOn, "days", true))
                  : "--"
                : "--"
            const lastStatusValue =
              updateDifference != "--" ? `${updateDifference} days` : "--"
            const crmName =
              !isEmpty(data.assignCrm) && data.assignCrm.length > 0
                ? data.assignCrm.map((m) => m.empCode + "-" + m.name).join()
                : "--"
            return {
              key: index,
              _id: data._id,
              sNo: index + 1,
              leadNo: data.leadNo,
              clientCode: data.clientCode ? data.clientCode : "--",
              clientName: data.clientName ? data.clientName : "--",
              groomName: groomName ? groomName : "--",
              brideName: brideName ? brideName : "--",
              crmName: crmName,
              productLeadName: teamName ? teamNameValue : "--",
              teamName: employeeName ? employeeNameValue : "--",
              productName: data.productName ? data.productName : "--",
              count: countValue,
              tatDate: data.tat ? moment(data.tat).format(dateFormat) : "--",
              link: data.link ? data.link : "--",
              plRemark: plRemarks ? plRemarks : "--",
              plAttachments: plAttachmentsValue,
              event: eventName,
              overallStatus: data.overAllStatus ? data.overAllStatus : "--",
              operationStatus: data.productioProcessStatusName
                ? data.productioProcessStatusName
                : "--",
              clearanceStatusName: data.ecClearanceStatusName ? data.ecClearanceStatusName : "--",

              cpStatus:
                data.clientProfileStatus && data.clientProfileStatus != null
                  ? data.clientProfileStatus
                  : "--",
              cpRemarks: cpRemarks,
              aging: data.deliverableAge
                ? `${data.deliverableAge}  days`
                : dayDiffValue,
              assignedDate: !isEmpty(data.tlAssigneDate)
                ? moment(data.tlAssigneDate).format(dateFormat)
                : "--",
              clientType: data.leadQuotationRange ? data.leadQuotationRange : "--",
              isEscalation: data.isOperationEscalation == true ? "YES" : "NO",
              lastStatus: lastStatusValue,
              onlyEngagement: data.onlyEngagement == true ? `YES (${data.onlyEngagementStatus})` : "NO",
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Lead No, Is Escalation,Client Type,Only Engagement, Client Code ,Client Name,CP Remarks,CP Status, Groom Name,Bride Name,Crm Name,Product Lead Name, Team Name,Aging,Assigned Date,Product Name,Count/Sheet,Tat Date,Deliverable Link,Deliverable Remarks,Deliverable Attachment,Event Name,Overall Status,Last Status,Deliverable Status, Clearance Status",
          ]

          let usersCsv =
            !isEmpty(postExportDataTable) &&
            postExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                isEscalation,
                clientType,
                onlyEngagement,
                clientCode,
                clientName,
                cpremarks,
                cpStatus,
                groomName,
                brideName,
                crmName,
                productLeadName,
                teamName,
                aging,
                assignedDate,
                productName,
                count,
                tatDate,
                link,
                plRemark,
                plAttachments,
                event,
                overallStatus,
                lastStatus,
                operationStatus,
                clearanceStatusName
              } = user
              acc.push([
                sNo,
                leadNo,
                isEscalation,
                clientType,
                onlyEngagement,
                clientCode,
                clientName,
                cpremarks,
                cpStatus,
                groomName,
                brideName,
                crmName,
                productLeadName,
                teamName,
                assignedDate,
                aging,
                productName,
                count,
                tatDate,
                link,
                plRemark,
                plAttachments,
                event,
                overallStatus,
                lastStatus,
                operationStatus,
                clearanceStatusName
              ])

              return acc
            }, [])
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "MyClientColorCorrected.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }
  //sorting

  const sortingOptions = [
    { label: "Ascending", value: "Ascending" },
    { label: "Descending", value: "Descending" },
  ]

  const columnOptions = [
    { label: "Client Name", value: "clientName" },
    { label: "Bride Name", value: "brideName" },
    { label: "Groom Name", value: "groomName" },
    { label: "Assigned Date", value: "assignedDate" },
    { label: "Tat Date", value: "tatDate" },
  ]
  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: 175, // Set your desired width here
    }),
  }

  const handleSorting = (e) => {
    setSortingDropdown(e)
    const payload = {
      ...searchValue,
      sortingOrder: e.value,
      sortingFieldName: sortingColumn.value,
    }
    //  setDownloadLoading(true)
    setTimeout(() => {
      dispatch(savePostAction.loadPostDetails(payload))
      setDownloadLoading(false)
    }, 1000)
  }
  const handleSortingColumn = (e) => {
    setSortingColumn(e)
    const payload = {
      ...searchValue,
      sortingOrder: sortingDropdown.value,
      sortingFieldName: e.value,
    }
    setDownloadLoading(true)
    setTimeout(() => {
      dispatch(savePostAction.loadPostDetails(payload))
      setDownloadLoading(false)
    }, 1000)
  }
  // remote pagination
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          {teamSubmitButton ? (
                            <Button
                              className="btn btn-danger text-nowrap"
                              onClick={() => {
                                setMultiTeamModal(true)
                                handleClearModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              Team Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            display: "flex",
                            marginRight: "10px",
                            //width:"100px"
                          }}
                        >
                          <Select
                            type="text"
                            name="sortingDropdown"
                            value={sortingDropdown}
                            onChange={(e) => handleSorting(e)}
                            options={sortingOptions}
                            placeholder="Select Sorting"
                            classNamePrefix="select2-selection"
                            styles={customStyles}
                          />
                        </div>
                        <div
                          style={{
                            float: "right",
                            display: "flex",
                            marginRight: "10px",
                            //width:"100px"
                          }}
                        >
                          <Select
                            type="text"
                            name="sortingColumn"
                            value={sortingColumn}
                            onChange={(e) => handleSortingColumn(e)}
                            options={columnOptions}
                            placeholder="Select Column"
                            classNamePrefix="select2-selection"
                            styles={customStyles}
                          />
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          noDataIndication={"No Data Found..."}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: magazine_details.length,
    data:
      !isEmpty(magazine_details) && magazine_details.length > 0
        ? magazine_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)

    let result =
      !isEmpty(magazine_details) && magazine_details.length > 0
        ? magazine_details
        : []
    if (
      !isEmpty(event) ||
      !isEmpty(clientMagazineData.leadNo) ||
      !isEmpty(clientMagazineData.eventStartDate) ||
      !isEmpty(clientMagazineData.eventEndDate) ||
      !isEmpty(clientMagazineData.assignedFromDate) ||
      !isEmpty(clientMagazineData.assignedToDate) ||
      !isEmpty(clientMagazineData.ewName) ||
      !isEmpty(clientMagazineData.brideName) ||
      !isEmpty(clientMagazineData.groomName) ||
      !isEmpty(deliverableStatus) ||
      !isEmpty(agent)||
      !isEmpty(clientType)||
      !isEmpty(clientMagazineData.tatFromDate) ||
      !isEmpty(clientMagazineData.tatToDate)
    ) {
      var searchLeadNo =
        clientMagazineData && clientMagazineData
          ? clientMagazineData.leadNo
          : ""
      var searchInProgress = inProgress === true ? "INPROGRESS" : ""
      var searchEvent = event && event ? event.value : ""
      var searchFromDate =
        clientMagazineData && clientMagazineData.eventStartDate
          ? moment(clientMagazineData.eventStartDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        clientMagazineData && clientMagazineData.eventEndDate
          ? moment(clientMagazineData.eventEndDate).format("YYYY-MM-DD")
          : ""
      var searchEmp = agent && !isEmpty(agent) ? [agent.value] : ""
      var searchAssignedFromDate =
        clientMagazineData && clientMagazineData.assignedFromDate
          ? moment(clientMagazineData.assignedFromDate).format("YYYY-MM-DD")
          : ""
      var searchAssignedToDate =
        clientMagazineData && clientMagazineData.assignedToDate
          ? moment(clientMagazineData.assignedToDate).format("YYYY-MM-DD")
          : ""
      var searchGroom =
        clientMagazineData && clientMagazineData.groomName
          ? clientMagazineData.groomName
          : ""
      var searchBride =
        clientMagazineData && clientMagazineData.brideName
          ? clientMagazineData.brideName
          : ""
      var searchEwName = !isEmpty(ewName) ? [ewName.value] : ""
      var searchDeliverable = !isEmpty(deliverableStatus) ? deliverables : ""
      var searchTatFromDate =
        clientMagazineData && clientMagazineData.tatFromDate
          ? moment(clientMagazineData.tatFromDate).format("YYYY-MM-DD")
          : ""
      var searchTatToDate =
        clientMagazineData && clientMagazineData.tatToDate
          ? moment(clientMagazineData.tatToDate).format("YYYY-MM-DD")
          : ""
      var searchClientType = !isEmpty(clientType) ? clientType.value : ""
      var searchvalue = {}
      if (searchClientType) {
        searchvalue.clientType = searchClientType
      }
      if (searchTatFromDate) {
        searchvalue.tatFromDate = searchTatFromDate
      }
      if (searchTatToDate) {
        searchvalue.tatToDate = searchTatToDate
      }
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      searchvalue.teamLeadId = teamLeadId
      searchvalue.sortingOrder = sortingDropdown.value
      searchvalue.sortingFieldName = sortingColumn.value
      searchvalue.productCategoryId = retouchId

      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchEvent) {
        searchvalue.eventNameId = searchEvent
      }
      if (searchFromDate) {
        searchvalue.eventStartDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.eventEndDate = searchToDate
      }
      if (searchEmp) {
        searchvalue.assignCrmId = searchEmp
      }
      if (searchAssignedFromDate) {
        searchvalue.assignedFromDate = searchAssignedFromDate
      }
      if (searchAssignedToDate) {
        searchvalue.assignedToDate = searchAssignedToDate
      }
      if (searchGroom) {
        searchvalue.groomName = searchGroom
      }
      if (searchBride) {
        searchvalue.brideName = searchBride
      }
      if (searchEwName) {
        searchvalue.assignedEmployeeId = searchEwName
      }
      if (searchDeliverable) {
        searchvalue.productionprocessstatus = searchDeliverable
      }
      if (searchInProgress) {
        searchvalue.subStatus = searchInProgress
      }
      setPageLoad(!pageLoad)

      setLoading(true)
      dispatch(clientAction.loadClientMagazine(searchvalue))
    } else {
      dispatch(
        clientAction.loadClientMagazine({
          page: page,
          limit: sizePerPage,
          productCategoryId: retouchId,
          teamLeadId: teamLeadId,
          sortingOrder: sortingDropdown.value,
          sortingFieldName: sortingColumn.value,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //Team assigne section
  const teamEmployeeValue = teamEmployee && teamEmployee.map((m) => m.value)
  const teamSubmit = () => {
    const team_details = {
      leadAssignDetail: [
        {
          leadId: teamAssignData.leadId,
          leadDelivarableId: teamAssignData.leadDeliverableId,
          leadEventId: teamAssignData.eventId,
        },
      ],
      menuMode: 3,
      employeeId: teamEmployeeValue,
      notes: teamData.note,
      attachments: uploadModalInput,
      assignedBy: empId,
    }
    dispatch(clientAction.addTeamAssign(team_details))
    setTimeout(() => {
      dispatch(clientAction.loadClientMagazine(searchValue))
      toast.success("Team Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }

  const teamMultipleEmployee =
    multiTeamEmployee && multiTeamEmployee.map((m) => m.value)
  const teamMultipleSubmit = () => {
    const teamDetails = {
      menuMode: 3,
      employeeId: teamMultipleEmployee,
      notes: multiTeamData.note,
      attachments: multiTeamFile,
      assignedBy: empId,
      leadAssignDetail: teamAssignDetails.map((data) => {
        return {
          leadId: data.leadId,
          leadDelivarableId: data.leadDeliverableId,
          leadEventId: data.eventId,
        }
      }),
    }
    dispatch(clientAction.addMultipleTeamAssign(teamDetails))
    setTimeout(() => {
      dispatch(clientAction.loadClientMagazine(searchValue))
      setTeamAssignDetails([])
      toast.success("Team Lead Assigned successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
      setMultiTeamModal(false)
    }, 1000)
  }
  const [uploadModalInput, setUploadModalInput] = useState([])
  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")

  const uploadModalChange = async (e) => {
    if (e.target.files) {
      setUploadModalInput(e.target.files)
      var file = e.target.files
      setFileName(file[0].name)
      setFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadModalInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadModalInput(teamUploadValue)
          }
        })
      }
    }
  }

  const [multiTeamFile, setMultiTeamFile] = useState([])
  const [teamFileName, setTeamFileName] = useState("")
  const [teamFileLength, setTeamFileLength] = useState("")
  const multiTeamChange = async (e) => {
    if (e.target.files) {
      setMultiTeamFile(e.target.files)
      var file = e.target.files
      setTeamFileName(file[0].name)
      setTeamFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiTeamFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiTeamFile(teamUploadValue)
          }
        })
      }
    }
  }

  const handleClearModal = () => {
    setTeamEmployee([])
    setMultiTeamEmployee([])
    setTeamData({ teamData, note: "" })
    setMultiTeamEmployee([])
    setMultiTeamData({ ...multiTeamData, note: "" })
    setUploadModalInput([])
    setMultiTeamFile([])
    setFileLength("")
    setFileName("")
    setTeamFileLength("")
    setTeamFileName("")
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"My Client"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Lead No"}>
                          {"Lead No"}
                        </Label>
                      </div>
                      <Input
                        type="text"
                        name="leadNo"
                        value={clientMagazineData.leadNo}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Lead No"
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event From Date"}
                        >
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventStartDate"
                        value={clientMagazineData.eventStartDate}
                        max={clientMagazineData.eventEndDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventEndDate"
                        value={clientMagazineData.eventEndDate}
                        min={clientMagazineData.eventStartDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Event</Label>
                      <Select
                        type="text"
                        name="event"
                        value={event}
                        onChange={(e) => setEvent(e)}
                        options={
                          recordsMetaData ? recordsMetaData.eventOptions : []
                        }
                        placeholder="Select Event"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"CRM Name"}>
                          {"CRM Name"}
                        </Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="agent"
                        key={agentKey}
                        items={recordsMetaData.employeeOptions}
                        value={agent}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setAgent(e)}
                        onChange={(e) => setAgent(e.target.value)}
                        onClear={() => setAgent([])}
                        placeholder="Enter CRM Name"
                        fuseOptions={fuseAgentOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"EW Name"}>
                          {"EW Name"}
                        </Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="agent"
                        key={agentKey}
                        items={recordsMetaData.employeeOptions}
                        value={ewName}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setEwName(e)}
                        onChange={(e) => setEwName(e.target.value)}
                        onClear={() => setEwName([])}
                        placeholder="Enter EW Name"
                        fuseOptions={fuseAgentOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Assigned From Date"}
                        >
                          {"EW Assigned From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="assignedFromDate"
                        value={clientMagazineData.assignedFromDate}
                        max={clientMagazineData.assignedToDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Assigned To Date"}
                        >
                          {"EW Assigned To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="assignedToDate"
                        value={clientMagazineData.assignedToDate}
                        min={clientMagazineData.assignedFromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Bride Name"}>
                          {"Bride Name"}
                        </Label>
                      </div>

                      <Input
                        type="text"
                        name="brideName"
                        value={clientMagazineData.brideName}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Bride Name"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Groom Name"}>
                          {"Groom Name"}
                        </Label>
                      </div>

                      <Input
                        type="text"
                        name="groomName"
                        value={clientMagazineData.groomName}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Groom Name"
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>
                          {"Deliverable Status"}
                        </Label>
                      </div>
                      <Select
                        type="text"
                        name="deliverableStatus"
                        value={deliverableStatus}
                        isMulti
                        onChange={(e) => setDeliverableStatus(e)}
                        options={deliverOptions}
                        placeholder="Select Deliverable Status"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                      <div className="d-flex flex-row">
                        {statusList.map((status, index) => {
                          return (
                            <div className="d-flex flex-row" key={index}>
                              <Input
                                type="checkbox"
                                name="inProgress"
                                value={status.value}
                                checked={inProgress === status.value}
                                onChange={(e) =>
                                  handleStatusChange(e, status.value)
                                }
                                className="font-size-15"
                              />
                              <Label
                                className="mx-2"
                                style={{ marginTop: "2px", fontSize: "12px" }}
                              >
                                {status.label}
                              </Label>
                            </div>
                          )
                        })}
                      </div>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Tat From Date"}
                          >
                            {"Tat From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="tatFromDate"
                          value={clientMagazineData.tatFromDate}
                          max={clientMagazineData.tatToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Tat To Date"}
                          >
                            {"Tat To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="tatToDate"
                          value={clientMagazineData.tatToDate}
                          min={clientMagazineData.tatFromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Client Type"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="clientType"
                          value={clientType}
                          onChange={(e) => setClientType(e)}
                          options={
                            [{ label: "Green", value: "Green" },
                            { label: "Orange", value: "Orange" },
                            { label: "Blue", value: "Blue" }]
                          }
                          placeholder="Select Client Type"
                          classNamePrefix="select2-selection"
                          isClearable={true}
                        />
                      </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>
                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>{" "}
                <RemotePagination
                  data={myClientMagazineTable}
                  page={page}
                  sizePerPage={sizePerPage}
                  totalSize={
                    !isEmpty(magazine_details)
                      ? magazine_details.totalDataCount
                      : 0
                  }
                  onTableChange={handleTableChange}
                />
                {loading ? (
                  <Modal
                    show={loading}
                    style={{ width: "7%", margin: "18% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                        color="success"
                      />
                      {/* <span>Loading...</span> */}
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
                {btnLoading ? (
                  <Modal
                    show={btnLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                        color="success"
                      />
                      {/* <span>Loading...</span> */}
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
                {downloadLoading ? (
                  <Modal
                    show={downloadLoading}
                    style={{ width: "7%", margin: "18% 50%" }}
                  >
                    <Modal.Body>
                      <Spinner
                        as="span"
                        animation="grow"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                        variant="success"
                        className="mx-2"
                        color="success"
                      />
                      {/* <span>Loading...</span> */}
                    </Modal.Body>
                  </Modal>
                ) : (
                  ""
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {columnModal && (
        <Modal size="xl" show={columnModal}>
          <Modal.Header
            style={{
              backgroundColor: "white",
              color: "black",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Edit Columns
            <span>
              <i
                className="fa fa-times quote-close"
                aria-hidden="true"
                onClick={() => setColumnModal(false)}
              ></i>
            </span>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <div>
                <Input
                  type="checkbox"
                  checked={selectedColumns.length === columns.length}
                  onChange={(e) => handleSelectAllChange(e)}
                  style={{ width: "15px", height: "15px" }}
                />
                <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                  Select All
                </Label>
              </div>
            </Row>
            <Row>
              <Col sm="12" md="6" lg="6" className="ml-4">
                {oddColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
              <Col sm="12" md="6" lg="6">
                {evenColumnData.map((column) => (
                  <div key={column.dataField} className="d-flex flex-row">
                    <div className="form-check form-check-inline">
                      <Input
                        type="checkbox"
                        value={column.dataField}
                        checked={selectedColumns.includes(column.dataField)}
                        onChange={(e) => handleCheckboxChange(e)}
                        style={{ width: "15px", height: "15px" }}
                      />
                      <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                        {column.text}
                      </Label>
                    </div>
                  </div>
                ))}
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <p
              className="text-decoration-underline text-info"
              style={{ cursor: "pointer", fontSize: "16px" }}
              onClick={handleRestoreToDefault}
            >
              Restore To Default
            </p>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => {
                setColumnModal(false)
                setSelectedColumns(selectColumn)
              }}
            >
              Close
            </Button>
            <Button
              variant="primary"
              className="btn btn-success"
              onClick={() => handleSaveColumns()}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {teamAssignModal && (
        <Modal size="xl" show={teamAssignModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Team
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                    {"Employee"}
                  </Label>
                </div>

                <Select
                  isMulti
                  type="text"
                  name="teamEmployee"
                  value={teamEmployee}
                  onChange={(e) => setTeamEmployee(e)}
                  options={
                    recordsMetaData ? recordsMetaData.employeeOptions : []
                  }
                  placeholder="Select Employee"
                  classNamePrefix="select2-selection"
                />
              </Col>
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="note"
                  value={teamData.note}
                  onChange={(e) => handleTeam(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col lg="2" md="2" sm="12" xs="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>
                    {"Attachment (JPG/PNG)"}
                  </Label>
                </div>
                <Button className=" btn btn-warning  position-relative fs-5">
                  <i className="fas fa-laptop"></i>

                  <Input
                    type="file"
                    name="uploadModalInput"
                    accept="application/pdf, audio/mp3 , image/jpeg"
                    // id="upload-btn"
                    multiple
                    onChange={(e) => uploadModalChange(e)}
                    style={{
                      position: "absolute",
                      fontSize: "50px",
                      opacity: 0,
                      right: 0,
                      top: 0,
                    }}
                  />
                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                    {fileLength ? fileLength : 0}
                  </span>
                </Button>
                <div className="text-decoration-underline text-danger">
                  {fileName ? fileName : ""}
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setTeamAssignModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {
                setTeamAssignModal(false)
                teamSubmit()
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {multiTeamModal && (
        <Modal size="xl" show={multiTeamModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Team
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Follow-Up-Date"}>
                    {"Employee"}
                  </Label>
                </div>

                <Select
                  isMulti
                  type="text"
                  name="multiTeamEmployee"
                  value={multiTeamEmployee}
                  onChange={(e) => setMultiTeamEmployee(e)}
                  options={
                    recordsMetaData ? recordsMetaData.employeeOptions : []
                  }
                  placeholder="Select Employee"
                  classNamePrefix="select2-selection"
                />
              </Col>
              <Col md="5" lg="5" xl="5" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="note"
                  value={multiTeamData.note}
                  onChange={(e) => handleMultiTeam(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col lg="2" md="2" sm="12" xs="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"}>
                    {"Attachment (JPG/PNG)"}
                  </Label>
                </div>
                <Button className=" btn btn-warning  position-relative fs-5">
                  <i className="fas fa-laptop"></i>

                  <Input
                    type="file"
                    name="multiTeamFile"
                    accept="application/pdf, audio/mp3 , image/jpeg"
                    // id="upload-btn"
                    multiple
                    onChange={(e) => multiTeamChange(e)}
                    style={{
                      position: "absolute",
                      fontSize: "50px",
                      opacity: 0,
                      right: 0,
                      top: 0,
                    }}
                  />
                  <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                    {teamFileLength ? teamFileLength : 0}
                  </span>
                </Button>
                <div className="text-decoration-underline text-danger">
                  {teamFileName ? teamFileName : ""}
                </div>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => {
                setMultiTeamModal(false)
                setTeamAssignDetails([])
              }}
            >
              Cancel
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {
                teamMultipleSubmit()
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {instructionsModal && (
        <Modal size="xl" show={instructionsModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Instructions
          </Modal.Header>
          <Modal.Body>
            <Row className="mt-3">
              <Table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Mode</th>
                    <th>Remarks</th>
                    <th>Created By</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(instructionsDetails) &&
                    instructionsDetails.length > 0 ? (
                    instructionsDetails.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data.mode}</td>
                          <td>{data.remarks}</td>
                          <td>{data.InsertByName}</td>
                          <td>{moment(data.createdAt).format(dateFormat)}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr key={0}>
                      <td className="text-align-center" colSpan={5}>
                        No Records Found...
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setInstructionsModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {/* Attachment Modal */}
      {attachmentModal && (
        <Modal size="md" show={attachmentModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Attachment
          </Modal.Header>
          <Modal.Body>
            <Row className="mt-3">
              <Col lg="12" md="12" sm="12" xs="12">
                <Label className="employee-label">
                  Attachment
                  {/* <span className="required mx-1">*</span> */}
                </Label>
                <Input
                  type="file"
                  // id="reject"
                  // value={rejectAttachment}
                  name="modalAttachment"
                  onChange={(e) => modalAttachmentChange(e)}
                  placeholder="Attach the files"
                  multiple
                />
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <div className="d-flex flex-row">
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setAttachmentModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="btn btn-success mx-2"
                data-bs-dismiss="modal"
                onClick={() => handleAttachment()}
              >
                Submit
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {ewAttachmentModal && (
        <Modal show={ewAttachmentModal} size="lg">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Attachments
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(ewAttachmentsDetails) &&
                      ewAttachmentsDetails.length > 0 ? (
                      ewAttachmentsDetails.map((item, index) => {
                        const splitAttach = !isEmpty(item)
                          ? item.split(".")
                          : ""
                        const attachExtension = !isEmpty(splitAttach)
                          ? splitAttach.pop()
                          : ""
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {" "}
                                {(item && attachExtension === "jpeg") ||
                                  (item && attachExtension === "jpg") ||
                                  (item && attachExtension === "png") ? (
                                  <a
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : (item && attachExtension === "mp3") ||
                                  (item && attachExtension === "m4a") ||
                                  (item && attachExtension === "mp4") ? (
                                  <a href={item}>
                                    <audio controls>
                                      <source src={item} type="audio/mpeg" />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={2} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={() => setEwAttachmentModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {crmAttachmentModal && (
        <Modal show={crmAttachmentModal} size="lg">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            CRM Attachments
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Crm Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(crmAttachmentsDetails) &&
                      crmAttachmentsDetails.length > 0 ? (
                      crmAttachmentsDetails.map((item, index) => {
                        const splitAttach = !isEmpty(item)
                          ? item.split(".")
                          : ""
                        const attachExtension = !isEmpty(splitAttach)
                          ? splitAttach.pop()
                          : ""
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {" "}
                                {(item && attachExtension === "jpeg") ||
                                  (item && attachExtension === "jpg") ||
                                  (item && attachExtension === "png") ? (
                                  <a
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : (item && attachExtension === "mp3") ||
                                  (item && attachExtension === "m4a") ||
                                  (item && attachExtension === "mp4") ? (
                                  <a href={item}>
                                    <audio controls>
                                      <source src={item} type="audio/mpeg" />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={2} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={() => setCrmAttachmentModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {plAttachmentModal && (
        <Modal show={plAttachmentModal} size="lg">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Deliverable Attachments
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Sl.No</th>
                      <th>Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(plAttachmentsDetails) &&
                      plAttachmentsDetails.length > 0 ? (
                      plAttachmentsDetails.map((item, index) => {
                        const splitAttach = !isEmpty(item)
                          ? item.split(".")
                          : ""
                        const attachExtension = !isEmpty(splitAttach)
                          ? splitAttach.pop()
                          : ""
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {" "}
                                {(item && attachExtension === "jpeg") ||
                                  (item && attachExtension === "jpg") ||
                                  (item && attachExtension === "png") ? (
                                  <a
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : (item && attachExtension === "mp3") ||
                                  (item && attachExtension === "m4a") ||
                                  (item && attachExtension === "mp4") ? (
                                  <a href={item}>
                                    <audio controls>
                                      <source src={item} type="audio/mpeg" />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={2} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={() => setPlAttachmentModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {historyModal && (
        <Modal size="xl" show={historyModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Assigned History
          </Modal.Header>
          <Modal.Body>
            <Row className="mt-3">
              <Table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Type</th>
                    <th>Employee Name</th>
                    <th>Notes</th>
                    <th>Attachment</th>
                    <th>Created On</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(history_details) &&
                    history_details.data.length > 0 ? (
                    history_details.data.map((data, index) => {
                      const employeeName =
                        data.PrecrmId !== undefined && !isEmpty(data.PrecrmId)
                          ? data.PrecrmId.name
                          : data.assignedTeamlead !== undefined &&
                            !isEmpty(data.assignedTeamlead)
                            ? data.assignedTeamlead[0].employeeId
                              .map((employee) => employee.name)
                              .join()
                            : data.assignEmployee !== undefined &&
                              !isEmpty(data.assignEmployee)
                              ? data.assignEmployee[0].employeeId
                                .map((employee) => employee.name)
                                .join()
                              : data.assignCrmEmployee !== undefined &&
                                !isEmpty(data.assignCrmEmployee)
                                ? data.assignCrmEmployee[0].employeeId
                                  .map((employee) => employee.name)
                                  .join()
                                : "--"

                      const typeName = data.PrecrmId
                        ? "CRM"
                        : data.assignedTeamlead
                          ? "PL"
                          : data.assignCrmEmployee
                            ? "CRM"
                            : data.assignEmployee
                              ? "EW"
                              : "--"

                      const notesName =
                        data.PrecrmId !== undefined &&
                          !isEmpty(data.PrecrmId) &&
                          data.PrecrmId.notes
                          ? data.PrecrmId.notes
                          : data.assignedTeamlead !== undefined &&
                            !isEmpty(data.assignedTeamlead) &&
                            data.assignedTeamlead[0].notes !== ""
                            ? data.assignedTeamlead[0].notes
                            : data.assignEmployee !== undefined &&
                              !isEmpty(data.assignEmployee) &&
                              data.assignEmployee[0].notes !== ""
                              ? data.assignEmployee[0].notes
                              : data.assignCrmEmployee !== undefined &&
                                !isEmpty(data.assignCrmEmployee) &&
                                data.assignCrmEmployee[0].notes !== ""
                                ? data.assignCrmEmployee[0].notes
                                : "--"
                      const createdOn =
                        data.PrecrmId !== undefined &&
                          !isEmpty(data.PrecrmId) &&
                          data.PrecrmId.createdOn
                          ? moment
                            .utc(data.PrecrmId.createdOn)
                            .format(`${dateFormat} ${"hh:mm A"}`)
                          : data.assignedTeamlead !== undefined &&
                            !isEmpty(data.assignedTeamlead)
                            ? moment
                              .utc(data.assignedTeamlead[0].createdOn)
                              .format(`${dateFormat} ${"hh:mm A"}`)
                            : data.assignEmployee !== undefined &&
                              !isEmpty(data.assignEmployee)
                              ? moment
                                .utc(data.assignEmployee[0].createdOn)
                                .format(`${dateFormat} ${"hh:mm A"}`)
                              : data.assignCrmEmployee !== undefined &&
                                !isEmpty(data.assignCrmEmployee)
                                ? moment
                                  .utc(data.assignCrmEmployee[0].createdOn)
                                  .format(`${dateFormat} ${"hh:mm A"}`)
                                : "--"
                      const createdBy =
                        data.PrecrmId !== undefined && !isEmpty(data.PrecrmId)
                          ? data.PrecrmId.createdByName
                          : data.assignedTeamlead !== undefined &&
                            !isEmpty(data.assignedTeamlead)
                            ? data.assignedTeamlead[0].createdByName
                            : data.assignEmployee !== undefined &&
                              !isEmpty(data.assignEmployee)
                              ? data.assignEmployee[0].createdByName
                              : data.assignCrmEmployee !== undefined &&
                                !isEmpty(data.assignCrmEmployee)
                                ? data.assignCrmEmployee[0].createdByName
                                : "--"
                      const attachment =
                        data.PrecrmId !== undefined && !isEmpty(data.PrecrmId)
                          ? data.PrecrmId.attachments
                          : data.assignedTeamlead !== undefined &&
                            !isEmpty(data.assignedTeamlead)
                            ? data.assignedTeamlead[0].attachments
                            : data.assignEmployee !== undefined &&
                              !isEmpty(data.assignEmployee)
                              ? data.assignEmployee[0].attachments
                              : data.assignCrmEmployee !== undefined &&
                                !isEmpty(data.assignCrmEmployee)
                                ? data.assignCrmEmployee[0].attachments
                                : "--"
                      const attachmentValue = !isEmpty(attachment)
                        ? attachment[0]
                        : []
                      const splitAttach = !isEmpty(attachmentValue)
                        ? attachmentValue.split(".")
                        : ""
                      const attachExtension = !isEmpty(splitAttach)
                        ? splitAttach.pop()
                        : ""
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{typeName}</td>
                          <td>{employeeName}</td>
                          <td>{notesName}</td>
                          <td>
                            {" "}
                            {(attachmentValue && attachExtension === "jpeg") ||
                              (attachmentValue && attachExtension === "jpg") ||
                              (attachmentValue && attachExtension === "png") ? (
                              <a
                                onClick={() =>
                                  window.open(attachmentValue, "_blank")
                                }
                              >
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    color: "#E40D8C",
                                  }}
                                >
                                  View
                                </span>
                              </a>
                            ) : (attachmentValue &&
                              attachExtension === "mp3") ||
                              (attachmentValue && attachExtension === "m4a") ||
                              (attachmentValue && attachExtension === "mp4") ? (
                              <a href={attachment}>
                                <audio controls>
                                  <source
                                    src={attachmentValue}
                                    type="audio/mpeg"
                                  />
                                  Your browser does not support the audio
                                  element.
                                </audio>
                              </a>
                            ) : (
                              "--"
                            )}
                          </td>
                          <td>{createdOn}</td>
                          <td>{createdBy}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr key={0}>
                      <td className="text-align-center" colSpan={7}>
                        No Records Found...
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setHistoryModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {processStatusModal && (
        <Modal size="xl" show={processStatusModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Deliverable Status
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-2">
              <Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" htmlFor={"Process Status"}>
                    {"Operation Status"}<span className="required"> *</span>
                  </Label>
                </div>

                <Select
                  // isMulti
                  type="text"
                  name="operationStatus"
                  value={operationStatus}
                  onChange={(e) => setOperationStatus(e)}
                  options={operationStatusNewOptions}
                  placeholder="Select Operation Status"
                  classNamePrefix="select2-selection"
                />
                <div style={{ textTransform: "capitalize" }}>
                  {simpleProcessValidator.current.message(
                    "Operation Status",
                    operationStatus,
                    "required"
                  )}
                </div>
              </Col>

              <Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Notes"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="notes"
                  value={processData.notes}
                  onChange={(e) => handleNotesChange(e)}
                  placeholder="Enter Notes"
                />
              </Col>
              <Col md="4" lg="4" xl="4" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Notes"}>
                    {"Attachment (JPG/PNG)"}
                  </Label>
                </div>
                <Input
                  type="file"
                  name="operationAttachment"
                  onChange={(e) => operationAttachmentChange(e)}
                  placeholder="Attach the files"
                  multiple
                />
              </Col>
            </Row>
            <Row className="quote-head-content">
              <Col md="6" lg="6" sm="12">
                <p className="quote-head">Process Status History</p>
              </Col>
            </Row>
            <Row>
              <Table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Mode</th>
                    <th>Employee Name</th>
                    <th>Deliverable Status</th>
                    <th>Notes</th>
                    <th>Attachment</th>
                    <th>Created By</th>
                    <th>Created On</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(processHistoryDetails) &&
                    processHistoryDetails.length > 0 ? (
                    processHistoryDetails.map((data, index) => {
                      const processStatus =
                        !isEmpty(recordsMetaData) &&
                          recordsMetaData.processStatusOptions &&
                          recordsMetaData.processStatusOptions.length > 0
                          ? recordsMetaData.processStatusOptions.find(
                            (_) => _.value === data.productionprocessstatus
                          )?.label
                          : "--"
                      const createdOn = !isEmpty(data.createdOn)
                        ? moment(data.createdOn)
                          .subtract(5, "hours")
                          .subtract(30, "minutes")
                          .format(`${dateFormat} ${"hh:mm A"}`)
                        : "--"
                      const empName =
                        data.employeName && data.employeCode
                          ? data.employeCode + "-" + data.employeName
                          : "--"
                      const attachment = !isEmpty(data.attachment)
                        ? data.attachment.map((m) => m).join()
                        : ""
                      const attachExtension = !isEmpty(attachment)
                        ? attachment.split(".").pop()
                        : ""
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data.mode ? data.mode : "--"}</td>
                          <td>{empName}</td>
                          <td>{processStatus}</td>
                          <td>{data.notes ? data.notes : "--"}</td>
                          <td>
                            {" "}
                            {(attachment && attachExtension === "jpeg") ||
                              (attachment && attachExtension === "jpg") ||
                              (attachment && attachExtension === "png") ? (
                              <a
                                onClick={() =>
                                  window.open(attachment, "_blank")
                                }
                              >
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    color: "#E40D8C",
                                  }}
                                >
                                  View
                                </span>
                              </a>
                            ) : (attachment && attachExtension === "mp3") ||
                              (attachment && attachExtension === "m4a") ||
                              (attachment && attachExtension === "mp4") ? (
                              <a href={attachment}>
                                <audio controls>
                                  <source src={attachment} type="audio/mpeg" />
                                  Your browser does not support the audio
                                  element.
                                </audio>
                              </a>
                            ) : (
                              "--"
                            )}
                          </td>
                          <td>
                            {data.createdByName ? data.createdByName : "--"}
                          </td>
                          <td>{createdOn}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td className="text-align-center" colSpan={8}>
                        No Records Found...
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setProcessStatusModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="submit"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={(e) => {
                processSubmit(e)
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {tatModal && (
        <Modal size="xl" show={tatModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Deliverable Update History
          </Modal.Header>
          <Modal.Body>
            {tatUpdate && (
              <Row className="mb-5">
                <Col md="3" lg="3" xl="3" sm="12">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"} htmlFor={"link"}>
                      {"Link"}
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="link"
                    value={tatData.link}
                    onChange={(e) => handleTatChange(e)}
                    placeholder="Enter Link"
                  />
                </Col>
                <Col md="3" lg="3" xl="3" sm="12">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"} htmlFor={"remarks"}>
                      {"Remarks"}
                    </Label>
                  </div>
                  <Input
                    type="textarea"
                    name="remarks"
                    value={tatData.remarks}
                    onChange={(e) => handleTatChange(e)}
                    placeholder="Enter Remarks"
                  />
                </Col>
                <Col md="3" lg="3" xl="3" sm="12">
                  <div className="d-flex justify-content-between">
                    <Label className={"form-label"} htmlFor={"Notes"}>
                      {"Attachment (JPG/PNG)"}
                    </Label>
                  </div>
                  <Input
                    type="file"
                    name="tatAttachment"
                    onChange={(e) => tatAttachmentChange(e)}
                    placeholder="Attach the files"
                    multiple
                  />
                </Col>
                <Col md="3" lg="3" xl="3" sm="12">
                  <div className="d-flex justify-content-between">
                    <Label
                      className={"form-label"}
                      htmlFor={"Deliverable Quantity"}
                    >
                      {"Deliverable Quantity"}
                    </Label>
                  </div>
                  <Input
                    type="text"
                    name="deliverableQuantity"
                    value={tatData.deliverableQuantity}
                    onChange={(e) => handleTatChange(e)}
                    placeholder="Enter Deliverable quantity"
                  />
                </Col>
              </Row>
            )}
            {tatView && (
              <Row className="mt-3">
                <Table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Mode</th>
                      <th>Tat Date</th>
                      <th>Link</th>
                      <th>Remarks</th>
                      <th>Attachment</th>
                      <th>Quantity</th>
                      <th>Created By</th>
                      <th>Created On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(operationHistoryDetails) &&
                      operationHistoryDetails.length > 0 ? (
                      operationHistoryDetails.map((data, index) => {
                        const tatDate = data.tat
                          ? moment(data.tat).format(dateFormat)
                          : "--"
                        const attachment = !isEmpty(data.attachment)
                          ? data.attachment.map((m) => m).join()
                          : ""

                        const attachExtension = !isEmpty(attachment)
                          ? attachment.split(".").pop()
                          : ""
                        const createdOn = !isEmpty(data.createdOn)
                          ? moment(data.createdOn)
                            .subtract(5, "hours")
                            .subtract(30, "minutes")
                            .format(`${dateFormat} ${"hh:mm A"}`)
                          : "--"
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.mode ? data.mode : "--"}</td>
                            <td>{tatDate}</td>
                            <td>{data.link ? data.link : "--"}</td>
                            <td>{data.remarks ? data.remarks : "--"}</td>
                            <td>
                              {" "}
                              {(attachment && attachExtension === "jpeg") ||
                                (attachment && attachExtension === "jpg") ||
                                (attachment && attachExtension === "png") ? (
                                <a
                                  onClick={() =>
                                    window.open(attachment, "_blank")
                                  }
                                >
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "#E40D8C",
                                    }}
                                  >
                                    View
                                  </span>
                                </a>
                              ) : (attachment && attachExtension === "mp3") ||
                                (attachment && attachExtension === "m4a") ||
                                (attachment && attachExtension === "mp4") ? (
                                <a href={attachment}>
                                  <audio controls>
                                    <source
                                      src={attachment}
                                      type="audio/mpeg"
                                    />
                                    Your browser does not support the audio
                                    element.
                                  </audio>
                                </a>
                              ) : (
                                "--"
                              )}
                            </td>
                            <td>{data.quantity ? data.quantity : "--"}</td>
                            <td>
                              {data.createdByName ? data.createdByName : "--"}
                            </td>
                            <td>{createdOn}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td className="text-align-center" colSpan={9}>
                          No Records Found...
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Row>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setTatModal(false)}
            >
              Cancel
            </Button>
            {tatUpdate ? (
              <Button
                type="submit"
                variant="secondary"
                className={"btn btn-success"}
                data-bs-dismiss="modal"
                onClick={(e) => historySubmit(e)}
              >
                update
              </Button>
            ) : (
              ""
            )}
          </Modal.Footer>
        </Modal>
      )}
      {eventServiceModal && (
        <Modal show={eventServiceModal} size="xl">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Event
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md="12" lg="12" xl="12" className="mt-3">
                <PaginationProvider
                  pagination={paginationFactory(options)}
                  keyField="index"
                  columns={eventColumns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="index"
                      data={deliverDataTable}
                      columns={eventColumns}
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row  ">
                              <Col>
                                <BootstrapTable
                                  {...props.baseProps}
                                  responsive
                                  striped={true}
                                  noDataIndication={"No Data Found..."}
                                  bordered={true}
                                  keyField="index"
                                  expandRow={expandRow}
                                  columns={eventColumns}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              onClick={() => setEventServiceModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {clientEventModal && (
        <Modal size="xl" show={clientEventModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Event
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md="12" lg="12" xl="12" className="mt-3">
                <PaginationProvider
                  pagination={paginationFactory(clientOptions)}
                  keyField="index"
                  columns={clientColumns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="index"
                      data={clientDataTable}
                      columns={clientColumns}
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row  ">
                              <Col>
                                <BootstrapTable
                                  {...props.baseProps}
                                  noDataIndication={"No Data Found..."}
                                  responsive
                                  striped={true}
                                  bordered={true}
                                  keyField="index"
                                  expandRow={clientExpandRow}
                                  columns={clientColumns}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setClientEventModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {tatNewModal && (
        <Modal size="md" show={tatNewModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Tat Update
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-5">
              <Col md="12" lg="12" xl="12" sm="12">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"Date"}>
                    {"Tat Date"}
                    <span className="required">*</span>
                  </Label>
                </div>
                <Input
                  type="date"
                  name="tat"
                  min={todayDate}
                  value={tatNewData.tat}
                  onChange={(e) => handleTatNewChange(e)}
                  placeholder="Enter Date"
                />
                <div style={{ textTransform: "capitalize" }}>
                  {simpleNewValidator.current.message(
                    "Tat Date",
                    tatNewData.tat,
                    "required"
                  )}
                </div>
              </Col>

              <Col md="12" lg="12" xl="12" sm="12" className="mt-3">
                <div className="d-flex justify-content-between">
                  <Label className={"form-label"} htmlFor={"remarks"}>
                    {"Remarks"}
                  </Label>
                </div>
                <Input
                  type="textarea"
                  name="remarks"
                  value={tatNewData.remarks}
                  onChange={(e) => handleTatNewChange(e)}
                  placeholder="Enter Remarks"
                />
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setTatNewModal(false)}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              variant="secondary"
              className={"btn btn-success"}
              data-bs-dismiss="modal"
              onClick={(e) => historyNewSubmit(e)}
            >
              update
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {tatHistoryModal && (
        <Modal size="xl" show={tatHistoryModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            TAT History
          </Modal.Header>
          <Modal.Body>
            <Row className="mt-3">
              <Table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Tat Date</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(tatHistoryDetails) &&
                    tatHistoryDetails.length > 0 ? (
                    tatHistoryDetails.map((item, index) => {

                      return (
                        <>
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.tat ? moment(item.tat).format(dateFormat) : "--"}</td>
                            <td>{item.remark ? item.remark : "--"}</td>

                          </tr></>)
                    })) :
                    (<tr key={0}>
                      <td className="text-align-center" colSpan={3}>
                        No Records Found...
                      </td>
                    </tr>)}

                </tbody>
              </Table>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setTatHistoryModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
MyClientColorCorrected.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyClientColorCorrected)
)
